import { render, staticRenderFns } from "./MaterialTypeNameEdit.vue?vue&type=template&id=2389fbc6&"
import script from "./MaterialTypeNameEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeNameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports